import { Backdrop, Divider, Fade } from "@material-ui/core";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import EditProfileRow from "./EditProfileRow";
import CloseModalButton from "Admin/Common/CloseModalButton";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "3rem auto",
    // Size to the form instead of a fixed 80% height, scrolling only when
    // the fields (e.g. counsel's extra rows) outgrow the viewport
    maxHeight: "calc(100vh - 6rem)",
    width: "50%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
    outline: "none",
    borderRadius: "0.4rem",
    overflowY: "auto",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      padding: theme.spacing(3, 4, 3),
    },
    [theme.breakpoints.down("sm")]: {
      width: "70%",
      padding: theme.spacing(3, 4, 3),
    },
  },
  editprofile: {
    fontWeight: "bold",
    fontSize: "24px",
    lineHeight: "23px",
    letterSpacing: "0.6px",
    color: TEXT.secondary,
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "18px",
    },
  },
}));

export default function EditProfile({
  openmodal,
  handleCloseModal,
  profileData,
  profileType,
  partyType,
  dispute_edit,
  refresh,
  caseId
}) {
  const classes = useStyles();

  const isMultiple = profileData.length ? true : false;

  // Some callers' close handlers call e.stopPropagation(), and there is no
  // click event to hand them once the save request resolves
  const closeAfterSave = () => handleCloseModal({ stopPropagation: () => {} });

  const body = (
    <div className={classes.paper}>
      <CloseModalButton onClick={handleCloseModal} />
      <Typography className={classes.editprofile}>Edit Profile</Typography>
      <Box height="1.5rem"></Box>
      {isMultiple ? (
        profileData
          .filter((profile) =>
            profile.profile ? profile.profile.profile_type == profileType : true
          )
          .map((profile, index) => (
            <React.Fragment key={profile.id || index}>
              {index > 0 && (
                <>
                  <Box height="1rem"></Box>
                  <Divider />
                  <Box height="1rem"></Box>
                </>
              )}
              <EditProfileRow
                profileData={profile}
                dispute_edit={dispute_edit}
                refresh={refresh}
                caseId={caseId}
                profileType={profileType}
                partyType={partyType}
              />
            </React.Fragment>
          ))
      ) : (
        <EditProfileRow
          profileData={profileData}
          dispute_edit={dispute_edit}
          refresh={refresh}
          caseId={caseId}
          profileType={profileType}
          partyType={partyType}
          onSaved={closeAfterSave}
        />
      )}
    </div>
  );

  return (
    <Modal
      open={openmodal}
      onClose={handleCloseModal}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      disableEnforceFocus
    >
      <Fade in={openmodal}>{body}</Fade>
    </Modal>
  );
}
